// Header component styles

export const pageTitleStyles = {
    className: 'page-title text-valhalla',
};

export const globalMenuLogoProps = {
    src: '/images/logo-dark.svg',
    alt: 'Mercell logo',
    width: '150px',
    height: '48px',
    className: 'header-logo',
};

export const standaloneHeaderStyles = {
    container: 'flex items-center col-span-full px-4 xl:px-8 2xl:px-16 pt-6',
    logo: {
        src: '/images/logo-dark.svg',
        alt: 'Mercell logo',
        width: '150px',
        height: '48px',
        className: 'hidden sm:block',
    },
    title: {
        className: 'font-light leading-8 text-valhalla -mt-0.5',
        style: { fontFamily: 'Inter', fontSize: 22 } as React.CSSProperties,
    },
};

export const repHeaderLogoProps = {
    src: '/images/logo-dark.svg',
    alt: 'Mercell logo',
    width: '150px',
    height: '48px',
};

export const repHeaderTitleStyles = {
    className: 'font-light leading-8 text-valhalla hidden md:block',
    style: { fontFamily: 'Inter', fontSize: 22 } as React.CSSProperties,
};
